import { useQuery } from '@zg-rentals/react-query5';
import { useDispatch } from 'react-redux';
import { copyApplicationLinkApi } from '../api';

export default function useCopyApplicationLink(listingAlias, applicationLink, useQueryOptions) {
  const dispatch = useDispatch();

  return useQuery({
    queryKey: ['handleApplicationInvitationLink', listingAlias, applicationLink],
    queryFn: () =>
      dispatch(
        copyApplicationLinkApi({
          listingAlias,
          applicationLink,
        }),
      ),
    ...useQueryOptions,
  });
}
